import React from 'react'
import Header from '../Components/Navbar';
import { Container } from 'reactstrap';
import GlitchClip from 'react-glitch-effect/core/GlitchClip';
import Footer from '../Components/Footer';

const About=()=> {
    return (
        <div className="aboutpage">
            <Header></Header>
        <div classname="abt-page"> 

            <Container>
                <div className="abt mt-2">
                
                    <div className="gbox">
                    <GlitchClip>
                        <h5 className="abt-btn">About_</h5>
                    </GlitchClip>
                    </div>
                    <p>Takshashila is a vibrant mix of fascinating and fun-filled events to rejoice life in all its facets.The event marks its significance by instilling the feeling of exuberance and togetherness amongst the students.The escapade fans out for a span of three days with the motif to accentuate the creative streak in each of us through the multitude of varying ventures curated for the young minds.
                    <br></br><br></br>The new normal comes with an opportunity to experience a fresh yet familiar event from the luxury and protection of your home. Experience the virtual reality that continues to set the standard by bringing a delegated fervor never witnessed before!</p>
                </div>
            </Container>
            
        </div>
        <Footer></Footer>  
        </div>
    )
}

export default About;